/**
 * FLX inline artwork — the four Daily Ritual visuals, transcribed verbatim from
 * the client's live site. Pure presentation, no props beyond the step index.
 *
 * These are inline SVG rather than image files on purpose (as on the live site):
 * they are flat brand shapes that must pick up `--orange` and stay crisp on the
 * paper background at any size.
 */
export function RitualVisual({ step }: { step: number }) {
  switch (step) {
    case 0:
      return (
        <svg viewBox="0 0 200 200">
          <g transform="translate(60 30)">
            <rect x="0" y="0" width="80" height="160" fill="#F25C05" />
            <rect x="0" y="0" width="80" height="14" fill="#0A0A0A" />
            <path
              d="M0 14 L8 18 L16 14 L24 18 L32 14 L40 18 L48 14 L56 18 L64 14 L72 18 L80 14 L80 10 L0 10 Z"
              fill="#0A0A0A"
            />
            <path d="M0 28 L12 34 L0 40 Z" fill="#0A0A0A" />
            <text
              x="40"
              y="100"
              textAnchor="middle"
              fontFamily="Barlow Condensed"
              fontWeight="900"
              fontStyle="italic"
              fontSize="28"
              fill="#fff"
            >
              5g
            </text>
          </g>
          <line
            x1="50"
            y1="80"
            x2="80"
            y2="80"
            stroke="#0A0A0A"
            strokeWidth="2"
            opacity="0.5"
            strokeDasharray="3 3"
          />
          <path d="M30 80 L60 66 L70 80 L60 94 Z" fill="#0A0A0A" opacity="0.85" />
        </svg>
      );
    case 1:
      return (
        <svg viewBox="0 0 200 200">
          <path
            d="M50 50 L150 50 L140 180 L60 180 Z"
            fill="none"
            stroke="#0A0A0A"
            strokeWidth="2"
          />
          <path d="M55 92 L145 92 L138 175 L62 175 Z" fill="#9CD9F2" opacity="0.55" />
          <ellipse cx="100" cy="92" rx="45" ry="6" fill="#9CD9F2" opacity="0.85" />
          <g transform="translate(70 0) rotate(-28 50 30)">
            <rect x="20" y="0" width="60" height="58" fill="#F25C05" />
            <rect x="20" y="0" width="60" height="10" fill="#0A0A0A" />
          </g>
          <path
            d="M118 40 Q108 64 100 92"
            stroke="#F25C05"
            strokeWidth="6"
            strokeLinecap="round"
            fill="none"
          />
          <circle cx="116" cy="46" r="2.5" fill="#F25C05" />
          <circle cx="111" cy="60" r="2" fill="#F25C05" />
          <circle cx="105" cy="74" r="2" fill="#F25C05" />
        </svg>
      );
    case 2:
      return (
        <svg viewBox="0 0 200 200">
          <rect x="62" y="44" width="76" height="126" rx="6" fill="#0A0A0A" />
          <rect x="58" y="36" width="84" height="12" rx="4" fill="#F25C05" />
          <rect x="78" y="86" width="44" height="20" fill="#F25C05" />
          <text
            x="100"
            y="101"
            textAnchor="middle"
            fontFamily="Barlow Condensed"
            fontWeight="900"
            fontStyle="italic"
            fontSize="14"
            fill="#fff"
          >
            FLX
          </text>
          <path
            d="M34 70 Q44 96 34 122"
            stroke="#F25C05"
            strokeWidth="2.5"
            fill="none"
            strokeLinecap="round"
          />
          <path
            d="M166 70 Q156 96 166 122"
            stroke="#F25C05"
            strokeWidth="2.5"
            fill="none"
            strokeLinecap="round"
          />
          <path
            d="M24 82 Q36 102 24 112"
            stroke="#F25C05"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            opacity="0.5"
          />
          <path
            d="M176 82 Q164 102 176 112"
            stroke="#F25C05"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            opacity="0.5"
          />
        </svg>
      );
    default:
      return (
        <svg viewBox="0 0 200 200">
          <g stroke="#0A0A0A" strokeOpacity="0.14">
            <line x1="20" y1="60" x2="180" y2="60" />
            <line x1="20" y1="100" x2="180" y2="100" />
            <line x1="20" y1="140" x2="180" y2="140" />
          </g>
          <g fill="#F25C05">
            <rect x="24" y="100" width="22" height="50" />
            <rect x="56" y="80" width="22" height="70" />
            <rect x="88" y="60" width="22" height="90" />
            <rect x="120" y="48" width="22" height="102" />
            <rect x="152" y="34" width="22" height="116" />
          </g>
          <text
            x="100"
            y="178"
            textAnchor="middle"
            fontFamily="Barlow Condensed"
            fontWeight="800"
            fontSize="13"
            fill="#0A0A0A"
            letterSpacing="2"
          >
            DAY 30 STREAK
          </text>
        </svg>
      );
  }
}
